<template>
    <div>
        <el-page-header content="礼物管理" title="礼物列表" class="page-header" />

        <!-- 礼物表格 -->
        <el-card class="gift-table-card" shadow="hover">
            <el-table :data="tableDate" style="width: 100%">
                <el-table-column prop="datatime" label="日期" width="120" align="center" />
                <el-table-column prop="title" label="标题" min-width="150" show-overflow-tooltip />
                <el-table-column label="内容" min-width="200">
                    <template #default="scope">
                        <div class="content-ellipsis" :title="scope.row.content">{{ scope.row.content }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="舰长填写表" align="center" width="120">
                    <template #default="scope">
                        <el-button type="primary" plain size="small" @click="handleJump(scope.row.address_1)">
                            访问
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="提督填写表" align="center" width="120">
                    <template #default="scope">
                        <el-button type="success" plain size="small" @click="handleJump(scope.row.address_2)">
                            访问
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="总督填写表" align="center" width="120">
                    <template #default="scope">
                        <el-button type="danger" plain size="small" @click="handleJump(scope.row.address_3)">
                            访问
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150" align="center" fixed="right">
                    <template #default="scope">
                        <div class="action-buttons-group">
                            <el-tooltip content="编辑" placement="top">
                                <el-button type="warning" :icon="EditPen" circle size="small"
                                    @click="openEditDialog(scope.row)" />
                            </el-tooltip>
                            <el-tooltip content="预览" placement="top">
                                <el-button type="info" :icon="Search" circle size="small"
                                    @click="openPreviewDialog(scope.row)" />
                            </el-tooltip>
                            <el-tooltip content="删除" placement="top">
                                <el-button type="danger" :icon="Delete" circle size="small"
                                    @click="handleDelete(scope.row)" />
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 礼物预览弹窗 -->
        <el-dialog v-model="previewDialogVisible" title="礼物预览" width="70%" top="5vh" custom-class="preview-dialog">
            <div class="preview-container">
                <el-card shadow="hover">
                    <div class="preview-header">
                        <div class="preview-field">
                            <el-icon>
                                <Calendar />
                            </el-icon>
                            <span>日期：</span>
                            <strong>{{ previewData.datatime }}</strong>
                        </div>
                        <div class="preview-field">
                            <el-icon>
                                <Document />
                            </el-icon>
                            <span>标题：</span>
                            <strong>{{ previewData.title }}</strong>
                        </div>
                    </div>

                    <el-divider>
                        <el-icon>
                            <Star />
                        </el-icon>
                    </el-divider>

                    <div class="preview-field">
                        <el-icon>
                            <Notebook />
                        </el-icon>
                        <span>内容：</span>
                        <p class="preview-content">{{ previewData.content }}</p>
                    </div>

                    <el-divider>
                        <el-icon>
                            <Picture />
                        </el-icon> 礼物展示
                    </el-divider>

                    <div class="image-grid">
                        <div v-for="i in 5" :key="i">
                            <div v-if="previewData[`image_${i}`]" class="image-preview">
                                <el-image :src="getImageUrl(previewData[`image_${i}`])" fit="cover" />
                            </div>
                        </div>
                    </div>
                </el-card>
            </div>

            <template #footer>
                <el-button type="primary" @click="previewDialogVisible = false">关闭预览</el-button>
            </template>
        </el-dialog>

        <!-- 编辑弹窗 -->
        <el-dialog v-model="editDialogVisible" title="编辑礼物" width="50%" top="5vh" custom-class="edit-dialog">
            <el-form :model="editForm" label-width="100px" label-position="left">
                <el-form-item label="日期" required>
                    <el-date-picker
                        v-model="editForm.datatime"
                        type="month"
                        placeholder="选择年月"
                        format="YYYY-MM"
                        value-format="YYYY-MM"
                        style="width: 100%">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="标题" required>
                    <el-input v-model="editForm.title" placeholder="请输入标题" />
                </el-form-item>

                <el-form-item label="内容" required>
                    <el-input v-model="editForm.content" type="textarea" :rows="4" placeholder="请输入内容" />
                </el-form-item>

                <el-form-item label="舰长表单">
                    <el-input v-model="editForm.address_1" placeholder="舰长填写表链接" />
                </el-form-item>

                <el-form-item label="提督表单">
                    <el-input v-model="editForm.address_2" placeholder="提督填写表链接" />
                </el-form-item>

                <el-form-item label="总督表单">
                    <el-input v-model="editForm.address_3" placeholder="总督填写表链接" />
                </el-form-item>

                <el-divider>礼物图片</el-divider>

                <el-form-item v-for="i in 5" :key="i" :label="'礼物图片 ' + i" class="image-upload-item">
                    <el-upload action="#" :show-file-list="false" :before-upload="(file) => beforeImageUpload(i, file)"
                        accept="image/*">
                        <div v-if="editForm[`image_${i}`]" class="image-container">
                            <el-image :src="getImageUrl(editForm[`image_${i}`])" fit="cover" class="uploaded-image" />
                            <div class="image-overlay">
                                <el-icon :size="20" @click.stop="handleRemoveImage(i)">
                                    <Delete />
                                </el-icon>
                            </div>
                        </div>
                        <el-icon v-else class="upload-icon">
                            <Plus />
                        </el-icon>
                    </el-upload>
                </el-form-item>
            </el-form>

            <template #footer>
                <el-button @click="editDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitEditForm">保存</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import {
    Calendar,
    Document,
    Notebook,
    Picture,
    Star,
    Plus,
    Delete as DeleteIcon
} from '@element-plus/icons-vue';
import {
    EditPen,
    Delete,
    Search
} from '@element-plus/icons-vue';
import axios from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus';
import { ASSET_BASE } from '../../../util/assetBase';

const previewDialogVisible = ref(false);
const editDialogVisible = ref(false);
const tableDate = ref([]);
const previewData = ref({});
const editForm = ref({
    datatime: '',
    title: '',
    content: '',
    address_1: '',
    address_2: '',
    address_3: '',
    image_1: null,
    image_2: null,
    image_3: null,
    image_4: null,
    image_5: null
});
const imageMimeTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

onMounted(async () => {
    await fetchGiftData();
});

async function fetchGiftData() {
    try {
        const res = await axios.get('/adminapi/gift/list');
        tableDate.value = res.data.results.map(item => {
            return {
                ...item,
                image_1: item.image_1 || null,
                image_2: item.image_2 || null,
                image_3: item.image_3 || null,
                image_4: item.image_4 || null,
                image_5: item.image_5 || null
            };
        });
    } catch (error) {
        ElMessage.error('数据加载失败');
        console.error(error);
    }
}

function getImageUrl(path) {
    if (!path) return '';
    // 如果是文件对象，创建临时URL
    if (path instanceof File) {
        return URL.createObjectURL(path);
    }
    // 如果是字符串路径，添加服务器地址
    return `${ASSET_BASE}/${path}`;
}

function handleJump(url) {
    if (url) {
        window.open(url, '_blank');
    } else {
        ElMessage.warning('未设置跳转链接');
    }
}

function openPreviewDialog(data) {
    previewData.value = {
        ...data,
        image_1: data.image_1 || null,
        image_2: data.image_2 || null,
        image_3: data.image_3 || null,
        image_4: data.image_4 || null,
        image_5: data.image_5 || null
    };
    previewDialogVisible.value = true;
}

// 记住打开弹窗时那条记录的 datatime：gift 表没有自增主键，只能用 datatime 定位，
// 管理员改了月份之后如果还拿新值当 WHERE 条件，就会找不到记录或覆盖别的月份
const originalDatatime = ref('');

function openEditDialog(data) {
    originalDatatime.value = data.datatime || '';
    editForm.value = {
        ...data,
        image_1: data.image_1 || null,
        image_2: data.image_2 || null,
        image_3: data.image_3 || null,
        image_4: data.image_4 || null,
        image_5: data.image_5 || null
    };
    editDialogVisible.value = true;
}

const beforeImageUpload = (index, file) => {
    if (!imageMimeTypes.includes(file.type)) {
        ElMessage.error('只能上传图片文件 (JPG, PNG, GIF, WEBP)');
        return false;
    }
    if (file.size > 10 * 1024 * 1024) {
        ElMessage.error('图片大小不能超过10MB');
        return false;
    }
    // 直接存储文件到对应的image_字段
    editForm.value[`image_${index}`] = file;
    return false;
};

const handleRemoveImage = (index) => {
    ElMessageBox.confirm('确定要删除这张图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        editForm.value[`image_${index}`] = null;
        ElMessage.success('图片已移除');
    }).catch(() => { });
};

async function submitEditForm() {
    try {
        // 验证必填字段
        if (!editForm.value.datatime || !editForm.value.title || !editForm.value.content) {
            ElMessage.error('请填写所有必填字段');
            return;
        }

        // 创建FormData对象
        const formData = new FormData();
        
        // 确保 image_1 到 image_5 始终存在
        for (let i = 1; i <= 5; i++) {
            const field = `image_${i}`;
            const value = editForm.value[field];
            
            // 如果值是文件对象，直接添加
            if (value instanceof File) {
                formData.append(field, value);
            }
            // 如果值未定义或空（表示需要删除）
            else if (value === null || value === undefined || value === '') {
                formData.append(field, 'null'); // 显式设置 null 字符串
            }
            // 其他情况（保留原始值）
            else {
                formData.append(field, value);
            }
        }
        
        // 添加其他非图片字段
        Object.entries(editForm.value).forEach(([key, value]) => {
            // 只添加非图片字段（image_1 到 image_5 已经处理过）
            if (!key.startsWith('image_') && value !== null && value !== undefined) {
                formData.append(key, value);
            }
        });

        // 原始 datatime 用来自我定位，后端优先用它做 WHERE
        formData.append('originalDatatime', originalDatatime.value || editForm.value.datatime);

        // 提交数据
        const response = await axios.put(
            `/adminapi/gift/update/${originalDatatime.value || editForm.value.datatime}`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );

        if (response.data && response.data.code !== 200) {
            throw new Error(response.data.message || '礼物更新失败');
        }

        ElMessage.success('礼物更新成功');
        editDialogVisible.value = false;
        await fetchGiftData();
    } catch (error) {
        console.error('提交失败:', error);
        ElMessage.error(error.response?.data?.message || '操作失败');
    }
}

function handleDelete(item) {
    ElMessageBox.confirm(
        `确定要删除"${item.datatime}"的礼物吗？`,
        '警告',
        {
            confirmButtonText: '确认删除',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(async () => {
        try {
            await axios.delete(`/adminapi/gift/delete/${item.datatime}`);
            ElMessage.success('礼物已删除');
            await fetchGiftData();
        } catch (error) {
            ElMessage.error('删除失败');
            console.error(error);
        }
    }).catch(() => { });
}
</script>

<style scoped>
.page-header {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.gift-table-card {
    border-radius: 10px;
    margin: 0 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.gift-table-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.content-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 250px;
}

.action-buttons-group {
    display: flex;
    gap: 8px;
}

.preview-container {
    padding: 10px;
}

.preview-header {
    display: flex;
    flex-wrap: wrap;
    gap: 25px;
    margin-bottom: 20px;
}

.preview-field {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    color: #666;
}

.preview-field .el-icon {
    font-size: 18px;
    color: #409eff;
}

.preview-content {
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 6px;
    line-height: 1.6;
    margin-top: 10px;
    color: #333;
    font-size: 15px;
}

.image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 15px;
    margin-top: 20px;
}

.image-preview {
    height: 150px;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
}

.image-preview:hover {
    transform: translateY(-3px);
}

.image-preview .el-image {
    width: 100%;
    height: 100%;
}

.image-upload-item {
    margin-bottom: 20px;
}

.upload-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    transition: border-color 0.3s;
}

.upload-icon:hover {
    border-color: #409eff;
}

.image-container {
    position: relative;
    width: 120px;
    height: 120px;
    overflow: hidden;
    border-radius: 6px;
}

.uploaded-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s;
    cursor: pointer;
}

.image-container:hover .image-overlay {
    opacity: 1;
}

.image-overlay .el-icon {
    color: white;
    font-size: 20px;
}

@media (max-width: 768px) {
    .preview-header {
        flex-direction: column;
        gap: 15px;
    }

    .action-buttons-group {
        justify-content: center;
    }

    .gift-table-card {
        margin: 0 10px;
    }
}
</style>